/**
 * Заявка за нова парола.
 *
 * Отговорът е един и същ за познат и непознат имейл — както на сървъра, така и
 * тук: иначе екранът се превръща в начин да се проверява кои адреси имат профил.
 */

import { useState } from 'react';
import { Button, Center, Paper, Stack, Text, TextInput, Title } from '@mantine/core';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { apiRequest } from '../api/client';

export function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  const submit = useMutation({
    mutationFn: () =>
      apiRequest('/api/auth/forgot-password', { method: 'POST', body: { email } }),
  });

  return (
    <Center h="100vh">
      <Paper withBorder p="xl" w={420}>
        {submit.isSuccess ? (
          <Stack>
            <Title order={3}>Проверете пощата си</Title>
            <Text size="sm" c="dimmed">
              Ако има профил с този имейл, на него е изпратен линк за задаване на нова парола.
              Линкът важи 48 часа.
            </Text>
            <Button variant="default" onClick={() => navigate('/')}>
              Към входа
            </Button>
          </Stack>
        ) : (
          <form
            onSubmit={(event) => {
              event.preventDefault();
              submit.mutate();
            }}
          >
            <Stack>
              <Title order={3}>Забравена парола</Title>
              <Text size="sm" c="dimmed">
                Въведете имейла си и ще получите линк за задаване на нова парола.
              </Text>
              <TextInput
                label="Имейл"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.currentTarget.value)}
                autoFocus
                required
              />
              <Button type="submit" loading={submit.isPending} fullWidth>
                Изпрати линк
              </Button>
              <Button variant="subtle" onClick={() => navigate('/')}>
                Назад към входа
              </Button>
            </Stack>
          </form>
        )}
      </Paper>
    </Center>
  );
}
